import { Formatting, type IMarkup, type LinkMarkupAttributes } from '@pressreader/content-types';

import { detectLinks } from './link.detection';

/**
 * Expresses the links detected in plain text as link markups.
 * @param text - Source text.
 * @returns Ascending, non-overlapping link markups whose offsets index the source text with an exclusive end.
 */
function synthesizeLinkMarkups(text?: string | null): IMarkup[] {
    return detectLinks(text).map<IMarkup>(match => {
        const attributes: LinkMarkupAttributes = { href: match.href };

        return {
            start: match.start,
            end: match.end,
            formatting: Formatting.Link,
            attributes,
        };
    });
}

export { synthesizeLinkMarkups };
